export enum WorkShopButton {
  Share = 'share',
  Get = 'get'
}
